import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import * as React from 'react';
const menu = ["ABOUT", "SKILL", "PORTFOLIO", "BLOG", "CONTACT"];
export default function MenuDrawer({ anchor, state, handleToggle, classes }) {

    return (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 200 }}
            role="presentation"
            onClick={() => handleToggle(false)}
            onKeyDown={() => handleToggle(false)}
        >
            <List>
                {menu.map((text, index) => (
                    <Link key={text} href={`#${text}`} className={classes.linkBtn}>
                        <ListItem button key={text}>

                            <ListItemText primary={text} id={text} />
                        </ListItem>
                    </Link>
                ))}
            </List>

        </Box>

    )
}
